'use strict';

var str = 'razdwatrzy';

module.exports = function () {
	if (typeof str.contains !== 'function') return false;
	return ((str.contains('dwa') === true) && (str.contains('foo') === false));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/event-emitter/~/es5-ext/string/#/contains/is-implemented.js
 ** module id = 17
 ** module chunks = 0
 **/